<template>
  <div class="view-container">
    <TheSimpleCourse />
  </div>
</template>

<script>
import TheSimpleCourse from './simple/TheSimpleCourse'

export default {
  components: { TheSimpleCourse }
}
</script>

<style lang="less" scoped>
.tabs-wrapper {
  background-color: #ffffff;
  .pane-body {
    padding-left: 1vw;
    padding-right: 1vw;
  }
}
</style>
